const Blockshard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
    <path fill="#151c2c" d="M-6.87-11.4h813.73v822.81H-6.87z" />
    <path
      fill="#12e1ff"
      d="M325.29 401.94l74.86 43.22 74.86-43.22-74.86-43.22z"
    />
    <path fill="#e7168b" d="M409.88 465.93v86.45l74.86-43.23v-86.44z" />
    <path fill="#6300f2" d="M390.32 465.93v86.45l-74.86-43.23v-86.44z" />
    <path
      fill="#fff"
      d="M586.77 350.12l-.13.02.02-.01-93.27-53.86L400 242.36l-39.84 24.7-44.75 27.47v73.28l85.15-51.03 60.74 35.07 61.19 35.32.21-.11-.1.11v141.64l-61.3 35.4-61.36 35.42-.06.14v-.23h.01l-61.19-35.33-61.3-35.4V126.27l-64.18 37.05v98.1l.01 76.8h-.01l.01 78.22-.01 149.42 93.39 53.92 93.28 53.85v-.11l.05.21 93.45-53.95 93.39-53.92V458.03z"
    />
  </svg>
);

export default Blockshard;
